/**
 * @file    js/email-antispam.js
 *
 * replaces anti-spam-modified emails with clickable email-links
 *
 * refactored version of depage-jquery-plugins/depage-email-antispam.js
 * without jquery
 *
 * copyright (c) 2009-2026 Frank Hellenkamp [jonas@depage.net]
 *
 * @author    Frank Hellenkamp [jonas@depage.net]
 */

// {{{ replaceEmailChars()
export function replaceEmailChars(mail) {
    mail = unescape(mail);
    mail = mail.replace(/ \*at\* /g, "@");
    mail = mail.replace(/ \*dot\* /g, ".");
    mail = mail.replace(/ \*punkt\* /g, ".");
    mail = mail.replace(/ \*underscore\* /g, "_");
    mail = mail.replace(/ \*unterstrich\* /g, "_");
    mail = mail.replace(/ \*minus\* /g, "-");
    mail = mail.replace(/mailto: /, "mailto:");

    return mail;
}
// }}}
// {{{ initAntiSpam()
export function initAntiSpam(root = document) {
    root.querySelectorAll("a[href*='mailto:']").forEach(function(el) {
        // replace attribute
        el.setAttribute("href", replaceEmailChars(el.getAttribute("href")));

        // replace content if necessary
        if (el.textContent.indexOf(" *at* ") > 0) {
            el.textContent = replaceEmailChars(el.textContent);
        }
    });
}
// }}}

// vim:set ft=javascript sw=4 sts=4 fdm=marker :
